// extracted by mini-css-extract-plugin
module.exports = {"departments":"pf","departmentHeading":"qf","departmentSection":"rf","departmentName":"sf","departmentLink":"tf","expandIcon":"uf"};